import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [show, setShow] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const handleClickHome = () => {
    window.scrollTo(0, 0);
    navigate("/");
  };
  const handleClickAbout = async () => {
    let path = location.pathname;
    if (path !== "/") {
      navigate("/");
      const element = await document.getElementById("about");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        scrollToSection("about");
      }
    }
    scrollToSection("about");
  };
  const handleClicklogo = () => {
    window.scrollTo(0, 0);
    navigate("/");
  };
  const handleClickProducts = () => {
    navigate("/product-service");
  };
  const handleClickGallery = () => {
    let path = location.pathname;
    if (path !== "/gallery") {
      navigate("/gallery/project1");
      scrollToSection("gallery");
    } else {
      scrollToSection("gallery");
    }
    navigate("/gallery/project1");
    scrollToSection("gallery");
  };
  const handleClickContact = async () => {
    let path = location.pathname;
    if (path !== "/") {
      navigate("/");
      const element = await document.getElementById("contact");

      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    scrollToSection("contact");
  };
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="header-fixed">
      <header className="Header">
        <img
          onClick={() => handleClicklogo()}
          src="header-logo.png"
          alt="Logo"
          className="logo-header"
        />
        <button className="sidebar-button" onClick={() => setShow(!show)}>
          {show ? (
            <i className="fa-solid fa-xmark"></i>
          ) : (
            <i className="fa-solid fa-bars"></i>
          )}
        </button>

        <ul className="menu">
          <li
            onClick={() => handleClickHome()}
            className="nav-link nav-link-ltr"
          >
            Home
          </li>
          <li
            onClick={() => handleClickAbout()}
            className="nav-link nav-link-ltr"
          >
            About
          </li>
          <li
            onClick={() => handleClickProducts()}
            className="nav-link nav-link-ltr"
          >
            Products
          </li>
          <li
            onClick={() => handleClickGallery()}
            className="nav-link nav-link-ltr"
          >
            Gallery
          </li>
          <li
            onClick={() => handleClickContact()}
            className="nav-link nav-link-ltr"
          >
            Contact
          </li>
        </ul>
      </header>
      {show === true ? (
        <div className="burger-menu sidebar">
          <div className="menu">
            <li
              onClick={() => handleClickHome()}
              className="nav-link nav-link-ltr"
            >
              Home
            </li>
            <li
              onClick={() => handleClickAbout()}
              className="nav-link nav-link-ltr"
            >
              About
            </li>
            <li
              onClick={() => handleClickProducts()}
              className="nav-link nav-link-ltr"
            >
              Products
            </li>
            <li
              onClick={() => handleClickGallery()}
              className="nav-link nav-link-ltr"
            >
              Gallery
            </li>
            <li
              onClick={() => handleClickContact()}
              className="nav-link nav-link-ltr"
            >
              Contact
            </li>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
